
<template>
    
    <div>
        <div style="display:flex; align-items:center;">
            <div class="mr-3">
                <div class="mt-5 ml-2">
                    <vs-avatar v-if="brokerData && brokerData.image" size="100px" :src="brokerData.image" />
                    <vs-avatar v-else  src="https://lemonspaces.com/frontend/images/broker.png"  size="100px" style="background:#FFFFFF;"/>      
                </div>
            </div>
            <h3 style="margin-left:10px;">{{brokerData ? brokerData.name : 'Loading...'}}</h3>
        </div>
        <div id="data-list-list-view" class="data-list-container">
            <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="brokerCommissions">
                <template slot="header">
                    <div style="display:flex; flex-direction: column; width:100%;">
                        

                        <months-and-years-filter 
                            @filterByMonth="(newMonthVal)=>{filterTableByMonth(newMonthVal)}" 
                            @filterByYear="(newYearVal) =>{filterTableByYear(newYearVal)}"
                        />

                        <div style="margin:10px 0; display:flex; justify-content: space-around;">
                            <div>
                                <h3 class="commissions-analytics">
                                    <feather-icon icon="TrendingUpIcon" class="text-success"></feather-icon>
                                    Total Commissions: <span>{{sumCommissions ? sumCommissions : 0}} EGP</span>
                                </h3><br>
                            </div>
                            <div>
                                <h3 class="commissions-analytics">
                                    <feather-icon icon="TrendingUpIcon" class="text-success" ></feather-icon>
                                    Average Commission: <span>{{avgCommissions ? avgCommissions : 0}} EGP</span>
                                </h3><br>
                            </div>
                            <div>
                                <h3 class="commissions-analytics">
                                    <feather-icon icon="TrendingUpIcon" class="text-success" ></feather-icon>
                                    Number of Bookings: <span>{{countCommissions ? countCommissions : 0}}</span>
                                </h3>
                            </div>

                        </div>
                    </div>  

                </template>

                <template slot="thead">
                <vs-th sort-key="promoCodeName">Promo Code Name</vs-th>
                <vs-th sort-key="promoCodeCommissionPercent">Promo Code Commission Percent %</vs-th>
                <vs-th sort-key="priceBeforeDiscount">Reservation Base Rate (USD)</vs-th>
                <vs-th sort-key="commission">Broker Commission (USD)</vs-th>
                <vs-th sort-key="exchangeRate">Exchange Rate</vs-th>
                <vs-th sort-key="commissionEGP">Broker Commission (EGP)</vs-th>
                <vs-th sort-key="guestBookingDate">Guest Booking Date</vs-th>
                <vs-th sort-key="guestName">Guest Name</vs-th>
                <vs-th sort-key="propertyNickName">Property Name</vs-th>
                <vs-th sort-key="reservationID">Reservation Id</vs-th>
                <vs-th sort-key="check_in">Check In</vs-th>
                <vs-th sort-key="check_out">Check Out</vs-th>
                </template>
                <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                    <p class="product-name font-bold">{{tr.promoCodeName}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.promoCodeCommissionPercent}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.priceBeforeDiscount}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.commission}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.exchangeRate}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.commissionEGP}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold" style="width: 80px;">{{tr.guestBookingDate}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.guestName}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold" style="width: 150px;">{{tr.propertyNickName}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold">{{tr.reservationID}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold" style="width: 80px;">{{tr.check_in}}</p>
                    </vs-td>
                    <vs-td>
                    <p class="product-name font-bold" style="width: 80px;">{{tr.check_out}}</p>
                    </vs-td>
                </vs-tr>
                </tbody>
                </template>
            </vs-table>
        </div>
    </div>
  </template>
  <script>
    import {mapGetters, mapActions} from 'vuex'
    import MonthsAndYearsFilter from '../FilterByMonthsAndYears.vue';
    export default {
      data() {
        return {
            sumCommissions : null,
            avgCommissions: null,
            countCommissions: null,
            form :{
                filter:{
                    month: -1,
                    year: new Date().getFullYear()
                },
            },
            itemsPerPage: 5,
            isMounted: false,
            stats: {},
            profileData: {}
        }
      },
      components: {
        MonthsAndYearsFilter
      },
      async created() {
        this.$vs.loading({ text: 'Loading Broker Info...' })
        await this.loadAllBrokers({
            storeName: 'brokers',
            url: `admin/brokers`,
            commitUrl: 'brokers/SET_BROKERS',
        })
        await this.loadBrokerData({
          commitUrl: 'brokers/GET_BROKER',
          id: this.$route.params.brokerID
        })
        this.$vs.loading.close()

        this.$vs.loading({ text: 'Loading Broker Commissions...' })
        await this.loadBrokerCommissions({
          storeName: 'brokerCommissions',
          url: `admin/brokers/get-commissions/${this.$route.params.brokerID}`,
          commitUrl: 'brokerCommissions/SET_BROKER_COMMISSIONS',
        })
        console.log(this.brokerCommissions)
        // this.$vs.loading.close()

        //this.$vs.loading({ text: 'Getting Commissions Analyzed Data...' })
        let commissionAnalysisData = await this.loadBrokerCommissionsAnalysis({
          url: `admin/brokers/get-commissions-analysis/${this.$route.params.brokerID}`
        })
        
        this.sumCommissions = commissionAnalysisData.data.data.sumCommissions
        this.avgCommissions = commissionAnalysisData.data.data.avgCommissions
        this.countCommissions = commissionAnalysisData.data.data.countCommissions

        this.$vs.loading.close()

      },
      computed: {
        ...mapGetters({
            brokerData: 'brokers/editItem',
            brokerCommissions: 'brokerCommissions/brokerCommissionsList',
            isLoading: 'brokerCommissions/isLoading',
            error: 'brokerCommissions/error',
        }),
        currentPage() {
          if(this.isMounted) {
            return this.$refs.table.currentx
          }
          return 0
        },
      },
      methods: {
        ...mapActions({
            loadAllBrokers: 'get',
            loadBrokerData: 'getLocalItem',
            loadBrokerCommissionsAnalysis: 'get',
            loadBrokerCommissions: 'get',
            deleteBroker: 'delete',
        }),
        errorNotify(){
          this.$vs.notify({color:'danger', title:'Error', text:this.error})
        },
        filterTableByMonth(val){
            this.form.filter.month = val
           this.updateTableRecords()
        },
        filterTableByYear(val){
            this.form.filter.year = val
            this.updateTableRecords()
        },
        async updateTableRecords(){
            this.$vs.loading({ text: 'Updating Commissions Records Based on Filters...' })
            await this.loadBrokerCommissions({
                storeName: 'brokerCommissions',
                url: `admin/brokers/get-commissions/${this.$route.params.brokerID}?month=${this.form.filter.month}&year=${this.form.filter.year}`,
                commitUrl: 'brokerCommissions/SET_BROKER_COMMISSIONS',
            })
            let commissionAnalysisData = await this.loadBrokerCommissionsAnalysis({
                url: `admin/brokers/get-commissions-analysis/${this.$route.params.brokerID}?month=${this.form.filter.month}&year=${this.form.filter.year}`
            })
            this.sumCommissions = commissionAnalysisData.data.data.sumCommissions
            this.avgCommissions = commissionAnalysisData.data.data.avgCommissions
            this.countCommissions = commissionAnalysisData.data.data.countCommissions

            this.$vs.loading.close()
        },
      },
      watch: {
        isLoading(newValue) {
          if (newValue) {
            this.$vs.loading()
          }else {
            this.$vs.loading.close()
          }
        },
        error(newValue) {
          if (newValue != null) {
            this.errorNotify()
          }
        }
      },
      mounted() {
        this.isMounted = true;
      }
    }
  </script>
  
  <style lang="scss">

  .commissions-analytics{
    margin: 5px 0px; background: rgb(255, 223, 72); 
    display: inline-block; 
    border-radius: 6px; 
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 30px;
    padding-left: 20px;
  }
  .commissions-analytics span{
    margin-right:10px; 
    top:5px;
  }
    #data-list-list-view {
      .vs-con-table {
  
        .vs-table--header {
          display: flex;
          flex-wrap: wrap-reverse;
          margin-left: 1.5rem;
          margin-right: 1.5rem;
          > span {
            display: flex;
            flex-grow: 1;
          }
  
          .vs-table--search{
            padding-top: 0;
  
            .vs-table--search-input {
              padding: 0.9rem 2.5rem;
              font-size: 1rem;
  
              &+i {
                left: 1rem;
              }
  
              &:focus+i {
                left: 1rem;
              }
            }
          }
        }
  
        .vs-table {
          border-collapse: separate;
          border-spacing: 0 1.3rem;
          padding: 0 1rem;
  
          tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 8px 20px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
          }
        }
  
        .vs-table--thead{
          th {
            padding-top: 0;
            padding-bottom: 0;
  
            .vs-table-text{
              text-transform: uppercase;
              font-weight: 600;
            }
          }
          th.td-check{
            padding: 0 15px !important;
          }
          tr{
            background: none;
            box-shadow: none;
          }
        }
  
        .vs-table--pagination {
          justify-content: center;
        }
      }
    }
  </style>
  